import { render, staticRenderFns } from "./SuggestPopup.vue?vue&type=template&id=fbc8d614&scoped=true"
import script from "./SuggestPopup.vue?vue&type=script&lang=js"
export * from "./SuggestPopup.vue?vue&type=script&lang=js"
import style0 from "./SuggestPopup.vue?vue&type=style&index=0&id=fbc8d614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc8d614",
  null
  
)

export default component.exports